<div class="collapsable-container">
    <div class="collapsable-container-header" (click)="toggleCollapse()">
        <span class="btn-collapse" (click)="toggleCollapse()"><span class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'INSTRUKCIJAPLACANJA.INTERMEDIARY.SINGULAR' | translate }}</div>
    </div>
    <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
        <yt-instrukcija-placanja-update #baseUpdate ></yt-instrukcija-placanja-update>
        <div class="row">
            <div class="col-md-12">
                <div class="btn-group float-right">
                  <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="this.baseUpdate.saveDisabled || this.baseUpdateComponent.baseFormGroup.disabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                  <button type="button" class="btn btn-outline-primary" (click)="Reset()" [disabled]="this.baseUpdate.resetDisabled || this.baseUpdateComponent.baseFormGroup.disabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div>
            </div>
        </div>
    </div>
</div>
